import axios from 'axios'
import { ROOT_URL } from '../utils/helpers'

import {
  FETCH_SPORT_VARIANT,
  FETCH_SPORT_VARIANT_SUCCESS,
  FETCH_SPORT_VARIANT_ERROR
} from './types'

export function fetchSportVariant (id, callback) {
  return function (dispatch) {
    dispatch({
      type: FETCH_SPORT_VARIANT
    })

    axios.get(`${ROOT_URL}/variants/${id}`)
      .then(response => {
        // If request is succesful
        // Update state with response info
        dispatch({
          type: FETCH_SPORT_VARIANT_SUCCESS,
          payload: response.data
        })
        response = response.data
        callback(response.data)
      })
      .catch(error => {
        // If request fails
        if (error.response) {
          const errors = error.response.data.errors
          dispatch({
            type: FETCH_SPORT_VARIANT_ERROR,
            payload: errors
          })
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/variants.js